export default __webpack_public_path__ + "static/media/27.684bcd33.jpg";